import { callApi } from "utils/api";
import crud from "./_crud";

const getSuppliesStationHistory = (station_id) => {
    return async (dispatch, getState) => {
        const state = getState();

        try {
            const res = await callApi(`/fuel_supply/get_history_by_station?station_id=${station_id}`, {
                method: 'GET',
                headers: {
                    Authorization: state.app.user.token
                }
            })

            return res.body;
        } catch (error) {
            console.log(error);
        }
    }
}

const getCustomStations = (params) => {
    return async (dispatch, getState) => {
        const state = getState();

        try {
            const res = await callApi(`/station/custom_stations`, {
                method: 'GET',
                headers: {
                    Authorization: state.app.user.token
                },
                params
            })

            return res.body;
        } catch (error) {
            console.log(error);
        }
    }
}

const saveMassiveFuelChanges = (changes, station_id) => {
    return async (dispatch, getState) => {
        const state = getState();

        try {
            const res = await callApi(`/station/save_massive_fuel_changes/${station_id}`, {
                method: 'POST',
                headers: {
                    Authorization: state.app.user.token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ changes })
            });

            return res.body;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}

const getUserStations = (userId) => {
    return async (dispatch, getState) => {
        const state = getState()
        try {
            const res = await callApi(`/station/user_assignments/${userId}`, {
                method: 'GET',
                headers: {
                    Authorization: state.app.user.token
                }
            })
            return res.body?.station_ids || []
        } catch (error) {
            console.log(error)
            return []
        }
    }
}

const assignUserStations = (userId, stationIds) => {
    return async (dispatch, getState) => {
        const state = getState()
        try {
            const res = await callApi(`/station/assign_user_stations`, {
                method: 'POST',
                headers: {
                    Authorization: state.app.user.token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ user_id: userId, station_ids: stationIds })
            })
            return res.body
        } catch (error) {
            console.log(error)
            throw error
        }
    }
}

const actions = crud('station', 'la estación', 'las estaciones');

export default {...actions, getSuppliesStationHistory, getCustomStations, saveMassiveFuelChanges, getUserStations, assignUserStations}